import axios from 'axios';
import funPdf from '../../utils/funPdf/funPdf';

const downloadPDF = funPdf.downloadPDF;
const SERVICE_GET_RISKS_URL = '/inventarios/riesgos';
const SERVICE_CREATE_RISK_URL = '/inventarios/riesgo/crear';
const SERVICE_EDIT_RISK_URL = '/inventarios/riesgo/edit';
const SERVICE_DELETE_RISK_URL = '/inventarios/riesgo/delete';
const GET_PDF_RIESGO_BOWTIE_URL = '/inventarios/riesgos/print_bowtie';
const GET_PDF_RIESGO_TABLA_URL = '/inventarios/riesgos/print_tabla';

const RECEIVE_RISKS = 'RECEIVE_RISKS';


const borra = { me: null };
function putoIEAssign(o, k, v) {
  borra.me = o[k];
  o[k] = v;
  delete borra.me;
}


const state = {
  all: [],
  loadingRisks: true,
};

const getters = {
  allRisks: state => state.all,
};

const actions = {
  getAllRisks({ commit }) {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    };
    // axios.get(SERVICE_GET_RISKS_URL, config)
    return axios.get(`${SERVICE_GET_RISKS_URL}/faena/${JSON.parse(localStorage.getItem('role')).faena_id}`, config)

      .then((response) => {
        commit(RECEIVE_RISKS, response.data);
      })
      .catch((error) => {
        commit(RECEIVE_RISKS, []);
        if (error) {
          console.log(error);
        }
      });
  },

  saveRisk({ commit, state }, risk) {
    return new Promise((resolve) => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      };
      axios.post(SERVICE_CREATE_RISK_URL, risk, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              status: false,
              message: response.data.message,
            });
          } else {
            resolve({
              status: true,
            });
          }
        })
        .catch((error) => {
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  editRisk({ commit, state }, risk) {
    return new Promise((resolve) => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      };
      const riskId = risk._id;
      delete risk._id;
      axios.put(`${SERVICE_EDIT_RISK_URL}/${riskId}`, risk, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              status: false,
              message: response.data.message,
            });
          } else {
            resolve({
              status: true,
            });
          }
        })
        .catch((error) => {
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  deleteRisk({ commit, state }, riskId) {
    return new Promise((resolve) => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      };
      axios.delete(`${SERVICE_DELETE_RISK_URL}/${riskId}`, config)
        .then((response) => {
          if (!response.data.success) {
            resolve({
              status: false,
              message: response.data.message,
            });
          } else {
            resolve({
              status: true,
            });
          }
        })
        .catch((error) => {
          if (error) {
            resolve({
              status: false,
              error: 'Lo sentimos, surgió un error. Intente nuevamente.',
            });
          }
        });
    });
  },
  getPDFRiesgoBowtie({
    commit,
  }, id) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(`${GET_PDF_RIESGO_BOWTIE_URL}/${id}`, config)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'PDFRiesgoBowtie.pdf');
            resolve();
          }
        });
    });
  },
  getPDFRiesgoTabla({
    commit,
  }, id) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.get(`${GET_PDF_RIESGO_TABLA_URL}/${id}`, config)
        .then((response) => {
          if (response.status === 200) {
            downloadPDF(response, 'PDFRiesgoTabla.pdf');
            resolve();
          }
        });
    });
  },
};

const mutations = {
  [RECEIVE_RISKS](state, risks) {
    putoIEAssign(state, 'all', risks);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
